module.exports = __webpack_public_path__ + "img/nofilter.4327d5a7.png";